import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    template: `<a *ngIf="clickable; else noClickable" href="#" (click)="$event.preventDefault(); click.emit(rowData);">
                   {{_value}}
               </a>
               <ng-template #noClickable>{{_value}}</ng-template>`,
})
export class CustomClickableCellComponent {

    constructor() { }

    _value: string;
    clickable = true;

    @Input() set value(value: any) {
        this.clickable = !(value.clickable === false);
        this._value = value.value || value;
    }

    @Input() rowData: any;

  /*eslint-disable */ @Output() click = new EventEmitter(); /*eslint-enable */
}
